// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ac9QMFTc3hysteT6370h > div > span {\n  font-weight: bold !important;\n}\n", "",{"version":3,"sources":["webpack://./web/static/components/lang-switch-dropdown.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B","sourcesContent":[".langSwitchDropdown > div > span {\n  font-weight: bold !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"langSwitchDropdown": "ac9QMFTc3hysteT6370h"
};
export default ___CSS_LOADER_EXPORT___;
